module.exports = __webpack_public_path__ + "img/13n.035cc16d.svg";